import { render } from "./timing-antivirus.vue?vue&type=template&id=2b52a3e1&scoped=true&ts=true"
import script from "./timing-antivirus.vue?vue&type=script&lang=ts"
export * from "./timing-antivirus.vue?vue&type=script&lang=ts"

import "./timing-antivirus.vue?vue&type=style&index=0&id=2b52a3e1&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b52a3e1"]])

export default __exports__